/**
 * Pure pagination helpers, kept free of browser globals so they can be reasoned
 * about (and tested) on their own.
 */

export const pageFromSearch = (search, pageParam = 'page') => {
  const value = parseInt(new URLSearchParams(search).get(pageParam), 10);

  return Number.isFinite(value) && value > 0 ? value : 1;
};

export const pageUrl = (pathname, search, page, pageParam = 'page') => {
  const params = new URLSearchParams(search);

  if (page > 1) {
    params.set(pageParam, String(page));
  } else {
    params.delete(pageParam);
  }

  const query = params.toString();

  return `${pathname}${query ? `?${query}` : ''}`;
};

/**
 * Page numbers to render, with `null` marking a gap:
 * 1 … 4 5 [6] 7 8 … 12
 */
export const buildPageList = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = new Set([1, totalPages, currentPage]);

  for (const page of [currentPage - 1, currentPage + 1]) {
    if (page > 1 && page < totalPages) {
      pages.add(page);
    }
  }

  const sorted = [...pages].sort((a, b) => a - b);

  return sorted.flatMap((page, index) =>
    index > 0 && page - sorted[index - 1] > 1 ? [null, page] : [page]
  );
};
